<template>
  <v-dialog 
  v-model="snackbar" 
  content-class="dialog-container"
  max-width="500"
  @keydown.esc="cancel()"
  transition="dialog-bottom-transition">
    <v-card class="dialog-card-border">
      <div class="title pa-3 font-weight-bold">
        Error
      </div>
      <div>
        Type: {{ error_type || 'Not specified'}}
      </div>
      <v-card-text v-show="!!text">{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn 
        class
        text
        outlined
        @click="snackbar = false">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!--
  <v-snackbar
    v-model="snackbar"
    :timeout="0"
    color="white blue-grey--text"
    bottom
    auto-height
    multi-line
    vertical="vertical"
  >

  <v-icon>warning</v-icon>

  <div class="text-xs-center font-weight-bold headline">Error</div>
  
  <v-layout>
    {{ text }}
  </v-layout>

  <v-layout>
    <v-spacer></v-spacer>
    <v-btn
      flat
      color="red"
      class="pl-4 pr-4 pt-1 pb-1"
      @click="snackbar = false"
    >
      Close
    </v-btn>
  </v-layout>

  </v-snackbar>
  -->
</template>

<script>
export default {
  data () {
    return {
      snackbar: false,
      timeout: 15000,
      text: 'Error: something',
      error_type: null
    }
  },
  methods: {
    open (error) {
      this.text = error.response.data.errors
      this.error_type = error.response.data.error_type
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
::v-deep .dialog-container {
  border-radius: 13px!important;
  width: auto;
}
.dialog-card-border {
  border: none;
}
.v-dialog__content {
  align-items: flex-end;
  text-align: center;
}
</style>
